module.exports = __webpack_public_path__ + "img/right-arrow.7666817f.svg";